module.exports = __webpack_public_path__ + "img/about.4606f5d4.jpg";